import type { ComponentType } from 'react'

import { HubspotSyncSection } from './HubspotSyncSection'
import { NexysConnections } from './Nexys'

/**
 * Extra sections rendered below the main vendor pane for a given vendor menu key.
 * Add an entry here to attach custom UI to any vendor page without forking the switch.
 */
export const vendorExtraSections: Record<string, ComponentType[]> = {
  hubspot: [HubspotSyncSection],
  Nexys: [NexysConnections],
}
